var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"dialog-modal-mask"},[_c('div',{class:{
                'xlarge-panel': _vm.isXLarge,
                'large-panel': _vm.isLarge,
                'medium-panel': _vm.isMedium,
                'long-panel': _vm.isLong,
                'small-panel': _vm.isSmall
            },on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"dialog-title"},[_vm._t("title")],2),_vm._v(" "),_c('hr',{staticClass:"dialog-hr"}),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_vm._t("body")],2),_vm._v(" "),_c('hr',{staticClass:"dialog-hr"}),_vm._v(" "),_c('div',{staticClass:"dialog-button-field"},[_vm._t("button")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }